<!-- Collapsed strip: the dock's always-visible single line. Click to expand
     the full detail panel below (desktop-only app — width is plentiful). -->
<div class="dock-strip" *ngIf="!isInactive" (click)="toggleExpanded()"
     [class.complete]="stripPercent === 100"
     [class.import]="!stripIsSync"
     title="{{ expanded ? 'Collapse' : 'Expand' }} details">
  <mat-icon class="dock-strip__icon"
            [class.rotating]="stripPercent > 0 && stripPercent < 100">{{ stripIsSync ? getSyncIcon() : (stripPercent === 100 ? 'check_circle' : 'cloud_upload') }}</mat-icon>
  <span class="dock-strip__label">{{ stripLabel }}</span>
  <div class="dock-strip__track">
    <div class="dock-strip__fill" [style.width.%]="stripPercent"></div>
  </div>
  <span class="dock-strip__pct">{{ stripPercent }}%</span>
  <span class="dock-strip__counts" *ngIf="stripTotal > 0">{{ stripCompleted | number }} / {{ stripTotal | number }}</span>
  <span class="dock-strip__meta" *ngIf="stripIsSync && syncProgress.estimatedTimeRemaining && stripPercent < 100">ETA {{ syncProgress.estimatedTimeRemaining }}</span>
  <span class="dock-strip__meta" *ngIf="stripIsSync && itemsPerMinute > 0">{{ itemsPerMinute | number }} items/min</span>
  <span class="dock-strip__bulk" *ngIf="bulkStatusSummary">{{ bulkStatusSummary }}</span>
  <mat-icon class="dock-strip__chevron">{{ expanded ? 'expand_more' : 'expand_less' }}</mat-icon>
</div>

<!-- Expanded detail panel: ADDITIVE data only. The strip above remains the
     single source for label + progress bar + % + counts; this panel adds the
     full metrics row, per-store bulk detail and import-pipeline detail. -->
<div class="dock-details"
     *ngIf="expanded && (syncProgress.totalItems > 0 || shopifySyncCounter > 0 || bulkStoreLines.length > 0 || (importProgress.isActive && stripIsSync))">

  <!-- Full sync metrics row: ETA / Processed / Remaining / Throughput / Speed / Elapsed / Done at -->
  <div class="sync-bar__metrics" *ngIf="syncProgress.totalItems > 0">
    <!-- ETA (most important to users) -->
    <div class="sync-bar__metric" *ngIf="syncProgress.percentage < 100">
      <span class="sync-bar__metric-label">ETA</span>
      <span class="sync-bar__metric-value sync-bar__metric-value--accent">{{ syncProgress.estimatedTimeRemaining || 'Calculating...' }}</span>
    </div>

    <!-- Processed / Total -->
    <div class="sync-bar__metric">
      <span class="sync-bar__metric-label">Processed</span>
      <span class="sync-bar__metric-value" [class.updating]="isCounterUpdating">
        {{ syncProgress.completedItems | number }}<span class="sync-bar__metric-dim"> / {{ syncProgress.totalItems | number }}</span>
      </span>
    </div>

    <!-- Remaining -->
    <div class="sync-bar__metric" *ngIf="remainingItems > 0">
      <span class="sync-bar__metric-label">Remaining</span>
      <span class="sync-bar__metric-value">{{ remainingItems | number }}</span>
    </div>

    <!-- Items / Min -->
    <div class="sync-bar__metric" *ngIf="itemsPerMinute > 0">
      <span class="sync-bar__metric-label">Throughput</span>
      <span class="sync-bar__metric-value">{{ itemsPerMinute }}<span class="sync-bar__metric-unit"> items/min</span></span>
    </div>

    <!-- Items / Sec -->
    <div class="sync-bar__metric" *ngIf="syncProgress.itemsPerSecond > 0">
      <span class="sync-bar__metric-label">Speed</span>
      <span class="sync-bar__metric-value">{{ syncProgress.itemsPerSecond }}<span class="sync-bar__metric-unit"> /sec</span></span>
    </div>

    <!-- Elapsed -->
    <div class="sync-bar__metric" *ngIf="elapsedDisplay">
      <span class="sync-bar__metric-label">Elapsed</span>
      <span class="sync-bar__metric-value">{{ elapsedDisplay }}</span>
    </div>

    <!-- Estimated Completion Time -->
    <div class="sync-bar__metric" *ngIf="estimatedCompletionTime">
      <span class="sync-bar__metric-label">Done at</span>
      <span class="sync-bar__metric-value">{{ estimatedCompletionTime }}</span>
    </div>
  </div>

  <!-- Queued fallback when no active sync data yet -->
  <div class="dock-details__row" *ngIf="syncProgress.totalItems === 0 && shopifySyncCounter > 0">
    <span class="dock-details__row-label">Queue</span>
    <span class="dock-details__row-text">{{ shopifySyncCounter }} sync job{{ shopifySyncCounter === 1 ? '' : 's' }} queued</span>
  </div>

  <!-- Per-store bulk detail: one stable line per store (BHS / MWS, max 2) -->
  <div class="dock-details__row" *ngIf="bulkStoreLines.length > 0">
    <span class="dock-details__row-label">Bulk sync</span>
    <div class="dock-details__lines">
      <span class="dock-details__row-text" *ngFor="let line of bulkStoreLines">{{ line }}</span>
    </div>
  </div>

  <!-- Import pipeline detail — only when the SYNC owns the strip and the
       import pipeline runs alongside it. When the import itself drives the
       strip, this row would repeat the strip verbatim. -->
  <div class="dock-details__row" *ngIf="importProgress.isActive && stripIsSync">
    <span class="dock-details__row-label">Import</span>
    <span class="dock-details__row-text">{{ importPhaseLabel }}</span>
    <span class="dock-details__row-count" *ngIf="importProgress.total > 0">{{ importProgress.completed | number }} / {{ importProgress.total | number }}</span>
  </div>

</div><!-- /dock-details -->
